import { useMemo } from "react";
import Widget from "../../../../../components/baseWidget";
import { useWidgetContext } from "../../../../../helpers/hooks/useWidgetContext";
import { useMeasure } from "react-use";
import BaseChart from "../../../../../components/baseChart";

const BarChart = ({ data, width, height }) => {
  const option = useMemo(() => {
    return {
      tooltip: {
        show: false,
      },
      legend: {
        show: true,
        formatter: "██████",
      },
      xAxis: {
        type: "category",
        data: ["Bob", "John", "Jane", "Jim", "Jill", "Jack"],
        axisLabel: {
          formatter: "██████",
        },
      },
      yAxis: [
        {
          name: "██████",
          type: "value",
          axisLabel: {
            formatter: "██████",
          },
        },
        {
          name: "██████",
          type: "value",
          axisLabel: {
            formatter: "██████",
          },
        },
      ],
      series: [
        {
          itemStyle: {
            color: "#58585E",
          },
          data: [10, 20, 30, 40, 50, 60],
          type: "bar",
        },
        {
          itemStyle: {
            color: "#3ECD89",
          },
          data: [234, 4354, 123, 4565, 323, 23],
          type: "line",
          yAxisIndex: 1,
        },
      ],
    };
  }, [data]);
  return <BaseChart height={height} width={width} options={option} />;
};

const BarChartWidgetSample = () => {
  const widget = useWidgetContext();
  const title = widget?.widgetData?.title;
  const [ref, { width, height }] = useMeasure();

  return (
    <Widget ref={ref}>
      <Widget.Header>
        <Widget.Title>{title}</Widget.Title>
      </Widget.Header>
      <Widget.Content>
        <BarChart data={[]} width={width} height={height} />
      </Widget.Content>
    </Widget>
  );
};

export default BarChartWidgetSample;
